"use client";

import React from "react";
import {
  OakUnitListItem,
  OakUnitListOptionalityItem,
} from "@oaknational/oak-components";
import Link, { LinkProps } from "next/link";

import type { Unit } from "@/types/ui";

type Props = {
  units: Unit[][];
  programmeSlug: string;
  unitsLessonListUrlTemplate: string;
  onUnitSelected?: (unit: Unit) => void;
};
export const UnitCards = ({
  units,
  programmeSlug,
  unitsLessonListUrlTemplate,
  onUnitSelected,
}: Props) => {
  const getUnitLink = (unitSlug: string) =>
    unitsLessonListUrlTemplate
      .replace(":programmeSlug", programmeSlug)
      .replace(":unitSlug", unitSlug);

  const getUnitListItem = (unit: Unit, i: number) => (
    <OakUnitListItem
      key={unit.unitSlug}
      as={Link}
      index={i + 1}
      title={unit.unitData.title}
      lessonCount={`${unit.lessonCount} lessons`}
      isLegacy={unit.isLegacy}
      href={getUnitLink(unit.unitSlug)}
      onClick={() => {
        onUnitSelected?.(unit);
      }}
    />
  );

  const getUnitListItemWithOptionality = (optionalUnits: Unit[], i: number) => {
    const optionalityUnits = optionalUnits.map((ou) => ({
      href: getUnitLink(ou.unitSlug),
      lessonCount: `${ou.lessonCount} lessons`,
      onClick: () => {
        onUnitSelected?.(ou);
      },
      slug: ou.unitSlug,
      title: ou.programmeFields.optionality ?? "",
      as: (props: LinkProps) => (
        <Link {...props} href={getUnitLink(ou.unitSlug)} />
      ),
    }));
    return (
      <OakUnitListOptionalityItem
        key={optionalUnits.map((u) => u.unitSlug).join("-")}
        // 0 indexed
        index={i + 1}
        nullTitle={optionalUnits?.[0]?.unitData?.title ?? ""}
        optionalityUnits={optionalityUnits}
        firstItemRef={undefined}
      />
    );
  };

  const unitCards = units.map((unit: Unit[], i) => {
    if (unit.length > 1) return getUnitListItemWithOptionality(unit, i);
    else return unit[0] ? getUnitListItem(unit[0], i) : undefined;
  });
  return <>{unitCards}</>;
};
